import style from "./button.module.css";

export default function Button({
  color = "blue", //red, darkblue, blue, outline
  text = "",
  enable = true,
  inactive = false,
  type = "submit",
  parentClassName = "",
  onClick = () => {},
  dataTestId,
}) {
  const onClickHandler = (e) => {
    enable ? onClick(e) : e.preventDefault();
  };

  return (
    <button
      type={type}
      className={`${parentClassName} ${style.btn} ${style[color]} ${
        enable ? style.enable : style.disable
      } ${inactive ? style.inactive : style.active}`}
      onClick={onClickHandler}
      dataTestId={dataTestId ?? `${text}-Button`}
    >
      {text}
    </button>
  );
}
